module.exports = __webpack_public_path__ + "img/d6.e0ca1286.png";